import { CSSProperties, SVGProps } from 'react'
import Colors from 'modules/Colors'

interface AppleFlatIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const AppleFlatIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 40,
    onClick
}: AppleFlatIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_181_172)">
                <path
                    d="M31.732 15.1022C31.5535 15.2407 28.4011 17.017 28.4011 20.9666C28.4011 25.5351 32.4124 27.1513 32.5324 27.1913C32.514 27.2898 31.8952 29.4047 30.4175 31.5596C29.0999 33.456 27.7239 35.3492 25.6305 35.3492C23.5372 35.3492 22.9984 34.1332 20.5818 34.1332C18.2268 34.1332 17.3895 35.3893 15.4747 35.3893C13.5598 35.3893 12.2238 33.6345 10.6876 31.4796C8.90829 28.9491 7.47064 25.0179 7.47064 21.2868C7.47064 15.3023 11.3618 12.1284 15.1914 12.1284C17.2263 12.1284 18.9225 13.4644 20.2001 13.4644C21.4161 13.4644 23.3124 12.0483 25.6274 12.0483C26.5048 12.0483 29.6571 12.1284 31.732 15.1022ZM24.5284 9.51474C25.4858 8.37879 26.1631 6.80261 26.1631 5.22644C26.1631 5.00787 26.1446 4.78622 26.1046 4.60767C24.5469 4.66616 22.6937 5.64511 21.5762 6.94114C20.6988 7.93857 19.8799 9.51474 19.8799 11.1125C19.8799 11.3526 19.92 11.5927 19.9384 11.6697C20.0369 11.6881 20.197 11.7097 20.3571 11.7097C21.7547 11.7097 23.5125 10.7738 24.5284 9.51474Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_181_172">
                    <rect width="25.0587" height="30.7847" fill="white" transform="translate(7.47064 4.60767)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default AppleFlatIcon
